module.exports = __webpack_public_path__ + "static/img/banner_mobile2.079c6f07.jpg";